import type { SubEvent } from '../../types/events.ts';

const trackingCutOffTimeHasPassedForAllSubEvents = (subEvents: SubEvent[]): boolean =>
  subEvents.every(
    (subEvent) =>
      subEvent.settings?.isPredictiveTrackingEnabled &&
      Date.now() >
        Date.parse((subEvent.settings?.trackingCutOffTime as string) ?? Date.now().toString())
  );

export default trackingCutOffTimeHasPassedForAllSubEvents;
